import React from 'react'
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import moment from 'moment'

import debounce from 'debounce'

import {
    Table,
    Card,
    Checkbox,
    Input,
    Button,
    Icon,
    Tag,
    Badge,
    Statistic,
    Row,
    Col,
} from 'antd'

import {
    _getBugs,
    _postSearchBugs
} from '../../services'

import Summary from './summary';

import './index.css'

const STATUS = {
    CLOSED: 'CLOSED',
    INPROGRESS: 'IN PROGRESS',
    OPEN: 'OPEN'
}

const RELATIONSHIP = {
    CUSTOMER: 'Customer',
    SUPPLIER: 'Supplier',
    PRESS: 'Press',
    PROSPECTIVE_CUSTOMER: 'Prospective Customer',
    PROSPECTIVE_SUPPLIER: 'Prospective Supplier',
    ADMIN: 'Admin',
}

const ORIGIN = {
    ADMIN: 'ADMIN',
    PUBLIC: 'PUBLIC'
}

const TYPE = {
    GENERAL: 'General',
    TECHINICAL: 'Technical',
    SUGGESTIONS: 'Suggestions'
}

const SEVERITYSTATUS = [
    {
        text: 'Can Ignore',
        color: '#EBF5FF'
    },
    {
        text: 'Low',
        color: '#99CEFF'
    },
    {
        text: 'Moderate',
        color: '#47A6FF'
    },
    {
        text: 'High',
        color: '#007EF5'
    },
    {
        text: 'GG',
        color: '#0054A3'
    },
    {
        text: 'GG NO RM',
        color: '#002A52'
    }
]

class BugManager extends React.Component {

    render() {

        const { page, limit, total, bugs, loading, agents, statusCount, newToday } = this.state

        // console.log({agents})

        const columns = [{
            title: 'Reference',
            dataIndex: 'refNumber'
        }, {
            title: 'Bug',
            dataIndex: 'description',
            width: 300,
            render: (description) => description.length > 50 ? description.slice(0,50).concat('...') : description
        }, 
        // {
        //     title: 'Date',
        //     dataIndex: 'dateCreated',
        //     render: (dateCreated) => moment(dateCreated).format('MMMM DD, YYYY h:mm A')
        // },
        {
            title: 'Days Open',
            dataIndex: 'dateCreated',
            render: (dateCreated) =>  moment().diff(moment(dateCreated),'days'),
            sorter: (a, b) => moment().diff(moment(a.dateCreated),'days') - moment().diff(moment(b.dateCreated),'days'),
            defaultSortOrder: 'descend',
        }, {
            title: 'Agent',
            dataIndex: 'agent',
            render: (agent) => agent ? agent.name : 'Unclaimed',
            filters: agents,
            filteredValue: this.state.agentFilter
        }, {
            title: "Status",
            dataIndex: 'status',
            render: (status) => {
                if (status == STATUS.CLOSED) {
                    return <Badge text={status} status={'default'} />
                }
                if (status == STATUS.OPEN) {
                    return <Badge text={status} status={'success'} />
                }
                if (status == STATUS.INPROGRESS) {
                    return <Badge text={status} status={'processing'} />
                }
            },
            filters: [{
                text: STATUS.CLOSED,
                value: STATUS.CLOSED
            }, {
                text: STATUS.OPEN,
                value: STATUS.OPEN
            }, {
                text: STATUS.INPROGRESS,
                value: STATUS.INPROGRESS
            }],
            filteredValue: this.state.statusFilter
        }, {
            title: 'Severity',
            dataIndex: 'severity',
            render: (severity) => {
                const status = SEVERITYSTATUS[severity]

                return <Badge color={status.color} text={status.text}/>
            },
            filters: SEVERITYSTATUS.map((_status, index) => ({ text: _status.text, value: index })),
            filteredValue: this.state.severityFilter
        }, {
            title: 'Origin',
            dataIndex: 'origin',
            render: (origin) => origin ? origin : ORIGIN.ADMIN,
            filters: Object.keys(ORIGIN).map((_origin) => ({ text: ORIGIN[_origin], value: ORIGIN[_origin] })),
            filteredValue: this.state.originFilter
        }, 
        // {
        //     title: 'Relationship',
        //     dataIndex: 'relationship',
        //     render: (relationship) => relationship ,
        //     filters: Object.keys(RELATIONSHIP).map((_relationship) => ({ text: RELATIONSHIP[_relationship], value:RELATIONSHIP[_relationship]} )),
        //     filteredValue: this.state.relationshipFilter
        // },
        {
            title: 'Type',
            dataIndex: 'type',
            render: (type) => type ,
            filters: Object.keys(TYPE).map((_type) => ({ text: TYPE[_type], value:TYPE[_type]} )),
            filteredValue: this.state.typeFilter
        },{
            title: 'Actions',
            render: (record) => <a href={`/bugs/${record._id}`} target="_blank">View</a>
        },
    
        ]

        // let statusCount = {} 

        // bugs.map(_bug => {
        //     if (statusCount[_bug.status]==undefined) {
        //         statusCount[_bug.status] = 1
        //     } else {
        //         statusCount[_bug.status] += 1
        //     }
        // })

        // let newToday = bugs.filter(_bug => {
        //     return moment(_bug.dateCreated).isAfter(moment().startOf('day'))
        // }).length

        return (
            <Card
                title={
                    <Row type="flex" justify="end">
                        <Input
                            style={{ width: 400, marginBottom: 0, marginRight: 'auto' }}
                            placeholder="Search Reference"
                            onChange={this.handleSearch}
                        />
                        <Button
                            target="_blank"
                            href={`/bugs/new`}
                            type="primary">
                            <Icon type="bug"/> Report
                        </Button>
                    </Row>
                }
            >
                <Row gutter={24} className="summary-container">
                    <Col span={8}>
                        <Row gutter={24} style={{marginBottom: 10, textAlign: 'center'}}>
                            <Col span={8}>
                                <Statistic title="Open Bugs" value={statusCount['OPEN']} />
                            </Col>
                            <Col span={8}>
                                <Statistic title="In Progress Bugs" value={statusCount['IN PROGRESS']} />
                            </Col>
                            <Col span={8}>
                                <Statistic title="New Today" value={statusCount['newToday']} />
                            </Col>
                        </Row>
                    </Col>
                    <Col span={16}>
                        <Summary 
                            allBugs = {this.state.allBugs}
                            key = {this.state.allBugs}
                            />
                    </Col>
                </Row>

                <Table
                    onChange={this.handleTableChange}
                    loading={loading}
                    dataSource={bugs}
                    columns={columns}
                    pagination={{
                        pageSize: limit,
                        current: page,
                        total,
                        onChange: (nextPage) => {
                            this.setState({ page: nextPage })
                        }
                    }}
                />
            </Card>
        )
    }

    constructor(props) {
        super(props)

        this.state = {
            bugs: [],
            page: 1,
            limit: 20,
            total: 0,
            searchTerm: '',
            loading: true,
            agents: [],
            allBugs: [],
            statusCount: {},

            statusFilter: [STATUS.OPEN, STATUS.INPROGRESS],
            severityFilter: [],
            originFilter: [],
            relationshipFilter: [],
            agentFilter: [],
            typeFilter: [],
        }

        this.getBugs()

        this.setSearch = debounce(this.setSearch, 400)
    }

    componentDidMount() {
        _postSearchBugs({
            page:1, 
            limit:10000000, 
            searchTerm:''
        })
        .then(res => {
            let agents = Array.from(new Set(res.data.bugs
                .map(_bug => _bug.agent? _bug.agent.name : 'Unclaimed')))
                .map(_agent => { return {text: _agent, value: _agent} })

            let statusCount = {} 

            res.data.bugs.map(_bug => {
                if (statusCount[_bug.status]==undefined) {
                    statusCount[_bug.status] = 1
                } else {
                    statusCount[_bug.status] += 1
                }
            })
    
            statusCount['newToday'] = res.data.bugs.filter(_bug => {
                return moment(_bug.dateCreated).isAfter(moment().startOf('day'))
            }).length

            this.setState({
                agents,
                allBugs: res.data.bugs,
                statusCount,
            })
        })
        .catch(err => console.log(err))
    }

    handleSearch = (e) => {
        this.setSearch(e.target.value)
    }

    handleTableChange = (pagination, filters, sorter, extra) => {

        this.setState({
            statusFilter: filters.status,
            severityFilter: filters.severity,
            originFilter: filters.origin,
            relationshipFilter: filters.relationship,
            agentFilter: filters.agent,
            typeFilter: filters.type,

            current: pagination.current
        }, this.getBugs)
    }

    setSearch = (searchTerm) => {
        this.setState({
            searchTerm
        }, this.getBugs)
    }

    getBugs = () => {

        this.setState({ loading: true })

        const { page, limit, searchTerm, statusFilter, severityFilter, originFilter, relationshipFilter, agentFilter, typeFilter } = this.state

        _postSearchBugs({
            page,
            limit,
            searchTerm,
            statusFilter,
            severityFilter,
            originFilter,
            relationshipFilter,
            agentFilter,
            typeFilter,
        })
            .then(res => {
                this.setState({
                    total: res.data.count,
                    bugs: res.data.bugs,
                    loading: false
                })
            })
    }
}


export default connect(
    state => ({
        // user: state.user
    })
)(withRouter(BugManager));


// WEBPACK FOOTER //
// ./src/components/bug-report/manager.js